<ng-container *ngIf="this.localizations && getCityCounts() && !showAsTooltip">
  <ng-container *ngFor="let localization of getCities(); let isLast=last">
    {{ localization | translate }}{{isLast ? '' : ', '}}
  </ng-container>
</ng-container>
<ng-container *ngIf="this.localizations && getCityCounts() && showAsTooltip">
  <jb-tooltip [icon]="'marker'" [data]="getCities()"></jb-tooltip>
</ng-container>
